<template>
  <div
    id="modalForm"
    class="modal fade bd-example-modal-lg"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title" id="exampleModalLabel">預設訊息</h3>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <template v-for="list in inputformList">
          <div class="margin-input col-md-12">
            <label class="fontSize14 col-md-2 col-sm-2 col-xs-2">
              {{ list.item }}
            </label>
            <input
              type="text"
              class="inputstyle fontSize14 col-md-9 col-sm-9 col-xs-9"
              v-model="list.content"
            />
          </div>
        </template>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">
            關閉
          </button>
          <button type="button" class="btn btn-secondary" @click="_save">
            儲存
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'

export default {
  props: {
    formList: {
      type: Array,
      default: function () {
        return [
          { item: '預設1', content: '' },
          { item: '預設2', content: '' },
          { item: '預設3', content: '' },
          { item: '預設4', content: '' },
          { item: '預設5', content: '' },
          { item: '預設6', content: '' },
        ]
      },
    },
  },
  data() {
    return {
      inputformList: this.formList,
      list: [],
    }
  },
  mounted() {
    // this._requestCusotmerService()
  },
  methods: {
    openModal() {
      $('#modalForm').modal('show')
    },
    _close() {
      $('#modalForm').modal('hide')
    },
    _save() {
      for (let i = 0; i < this.inputformList.length; i++) {
        let item = this.inputformList[i].content
        if (item !== '') {
          this.list.push(item)
        }
      }
      let serviceList = {
        service: this.list,
      }
      // {"service": ["刷卡","付現","信用卡","line","google"]}
      // console.log(serviceList)
      //更新
      API.put(`customerize-service/update`, serviceList)
        .then((data) => {
          if (data.result) {
            alert('修改成功')
            this._close()
            return
          }
          alert(data.message)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    _requestCusotmerService() {
      API.get(`customerize-service/customerize_service`)
        .then((service) => {
          if (service.success) {
            // 將資料帶進表單中
            let serviceArray = JSON.parse(service.result)
            for (let i = 0; i < serviceArray.length; i++) {
              this.inputformList[i].content = serviceArray[i].service
            }
          }
        })
        .catch((err) => {
          console.log('-------->updatedPayment', err)
        })
    },
  },
}
</script>
<style scoped>
.margin-input {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/components/ModalForm.vue